import React, { useState } from 'react';
import ConnectivityLogsSummary from './ConnectivityLogsSummary';
import ConnectivityLogsPanel from './ConnectivityLogsPanel';

const ConnectivityLogs = () => {
    const [isPanelVisible, setIsPanelVisible] = useState(false);

    const handleIsPanelVisible = (bool: boolean) => {
        setIsPanelVisible(bool);
    };

    return (
        <>
            <ConnectivityLogsSummary
                handleIsPanelVisible={handleIsPanelVisible}
            />
            <ConnectivityLogsPanel
                open={isPanelVisible}
                onClose={() => handleIsPanelVisible(false)}
            />
        </>
    );
};

export default ConnectivityLogs;
